import { useMemo } from 'react';
import useTheme from 'branding/theme';
const useLinkStyles = ({ isHovered, isFocused, inverted, small, styles }) => {
    const { typography, colors, borders } = useTheme();
    return useMemo(() => ({
        ...(small ? typography.link.small : typography.link.regular),
        ...((isHovered || isFocused) && { color: colors.brand.primary.alpha }),
        ...(inverted && { ...typography.inverted, ...borders.variant.inverted }),
        ...styles
    }), [styles, small, inverted, typography, isHovered, isFocused, colors, borders]);
};
export default useLinkStyles;
//# sourceMappingURL=useLinkStyles.js.map